import type { Inspector, Lawyer } from '../types';
import type { CompanyTheme } from '../components/company-theme/companyTheme';

/** Shared by Extern hjälp and the project's Extern hjälp tab (ClickUp 869fk17e6). */
export type ExpertType = 'lawyer' | 'inspector';
/** A lawyer or inspector as the API lists them, with their own theme when they have one (ClickUp 869fa6nt2). */
export type Expert = (Lawyer | Inspector) & {
  theme?: CompanyTheme | null;
  /** The API sends phone and email only once the expert said yes to one of the viewer's projects. */
  contactVisible?: boolean;
};

export const expertInitials = (name: string) =>
  name.split(/[\s-]+/).filter(Boolean).map(part => part[0]).join('').substring(0, 2).toUpperCase();

export const expertFirm = (provider: Expert, type: ExpertType) => type === 'lawyer'
  ? (provider as Lawyer).lawyerCompanyName
  : (provider as Inspector).inspectorCompanyName;

/** A sole trader often has the company named after the person: skip the repeat. */
export const displayFirm = (name: string, firm: string | undefined) =>
  firm && firm.trim().toLowerCase() !== name.trim().toLowerCase() ? firm : '';

export const expertPresentation = (provider: Expert, type: ExpertType) => type === 'lawyer'
  ? (provider as Lawyer).lawyerPresentation
  : (provider as Inspector).inspectorPresentation;

/** One expert: a wide card. Several: a row each, so a lone card never sits in a third of the width. */
export const expertLayout = (count: number): 'card' | 'row' => count === 1 ? 'card' : 'row';
